import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import baseUrl from "../../../../../../../../api/baseUrl";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleIcon from "@mui/icons-material/AddCircle";
type FormDataType = {
  treatmentkey: number;
  treatment: string;
  treatments: string;
  treatmentId: string;
  type: string;
  types: string;
  typeId: string;
  subtype: string;
  subtypes: string;
  subtypeId: string;
  toothNos: string;
  toothNo: string;
  prices: number;
  price: number;
  description: string;
  createdAt: Date;
  quantity: number;
  note: string;
  surface: string;
  didBy?: string; // Make didBy optional
  reason?: string; // Make didBy optional
};
function AddSubTreatmentModel({
  setSubTreatmentOpen,
  TreatmentId,
  setallTeatment,
  allTeatment,
}: any) {
  const { ID } = useParams();
  const [openOther, setopenOther] = useState(false);
  const [otherserror, setotherserror] = useState(false);
  const [error, seterror] = useState(false);
  const [reasonerror, setreasonerror] = useState(false);
  const [data, setData] = useState([]);
    const textareaRef = useRef<HTMLTextAreaElement>(null);
  
  const initialFormData: FormDataType = {
    treatmentkey: Math.floor(Math.random() * 9) + 1,
    treatment: "",
    treatments: "",
    treatmentId: "",
    type: "",
    types: "",
    typeId: "",
    subtype: "",
    subtypes: "",
    subtypeId: "",
    toothNos: "",
    toothNo: "",
    prices: 0,
    price: 0,
    description: "",
    createdAt: new Date(),
    quantity: 1,
    note: "",
    surface: "",
    reason: "",
  };

  // Conditionally add didBy field if doctorid is present

  const [formData, setformData] = useState(initialFormData);

  useEffect(() => {
    baseUrl
      .get("alltreatment/findAllTreatment")
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
    setopenOther(true);
    setformData((prevState) => ({
      ...prevState,
      ["treatments"]: "others",
      prices: 0 || NaN,
      treatment: "others",
      treatmentId: "others",
    }));
  }, []);
  const onchange = (e: any) => {
    const { value, name } = e.target;

    if (name === "treatments") {
      if (value === "others") {
        setopenOther(true);
        setformData((prevState) => ({
          ...prevState,
          [name]: value,
          prices: 0,
          treatment: value,
          treatmentId: value,
        }));
      } else {
        setopenOther(false);

        const separatedArray = value.split("/");

        setformData((prevState) => ({
          ...prevState,
          [name]: value,
          treatmentId: separatedArray[0],
          treatment: separatedArray[1],
          prices: separatedArray[2],
        }));
      }
    } else {
      if (formData.treatment === "others") {
        if (name === "types") {
          const separatedArray = value.split("/");
          setformData((prevState) => ({
            ...prevState,
            [name]: value,
            typeId: separatedArray[0],
            type: separatedArray[1],
            prices: separatedArray[2],
          }));
        } else if (name === "subtypes") {
          const separatedArray = value.split("/");
          setformData((prevState) => ({
            ...prevState,
            [name]: value,
            subtypeId: separatedArray[0],
            subtype: separatedArray[1],
            prices: separatedArray[2],
          }));
        } else if (name === "quantity") {
          setformData((prevState) => ({
            ...prevState,
            [name]: value,
            // price: formData.quantity
          }));
        } else if (name === "note") {
          if (textareaRef.current) {
            textareaRef.current.style.height = "auto"; // Reset height
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set height to fit content
          }
          setformData((prevState) => ({
            ...prevState,
            [name]: value,
            // price: formData.quantity
          }));
        } else{
          setformData((prevState) => ({
            ...prevState,
            [name]: value,
          }));
        }
      } else {
        if (name === "types") {
          const separatedArray = value.split("/");
          setformData((prevState) => ({
            ...prevState,
            [name]: value,
            typeId: separatedArray[0],
            type: separatedArray[1],
            prices: separatedArray[2],
          }));
        } else if (name === "subtypes") {
          const separatedArray = value.split("/");
          setformData((prevState) => ({
            ...prevState,
            [name]: value,
            subtypeId: separatedArray[0],
            subtype: separatedArray[1],
            prices: separatedArray[2],
          }));
        } else if (name === "quantity") {
          setformData((prevState) => ({
            ...prevState,
            [name]: value,
            // price: formData.quantity
          }));
        } else if (name === "prices") {
          setformData((prevState) => ({
            ...prevState,
          }));
        } else if (name === "note") {
          if (textareaRef.current) {
            textareaRef.current.style.height = "auto"; // Reset height
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set height to fit content
          }
          setformData((prevState) => ({
            ...prevState,
            [name]: value,
            // price: formData.quantity
          }));
        } else{
          setformData((prevState) => ({
            ...prevState,
            [name]: value,
          }));
        }
      }
    }
  };

  const onsubmit = (e: any) => {
    e.preventDefault();
    setotherserror(false);
    setreasonerror(false);
    let formDatas = {};
    if (selectedOption === "nontreatment") {
      if (formData.reason === "") {
        setreasonerror(true);
        return;
      }
      const data = {
        reason: formData.reason,
        treatment: formData.reason,
        treatmentkey: formData.treatmentkey,
        toothNo: formData.toothNo,
        surface: formData.surface,
        note: formData.note,
        createdAt: formData.createdAt,
        selectedOption: "non_treatment",
        treatments: "others",
      };
      formDatas = data;
    } else {
      if (formData.treatments === "others") {
        if (formData.description === "") {
          setotherserror(true);
          return;
        }
        if (selectedPaid === "nonpaid") {
          formDatas = {
            ...formData,
            selectedOption: "treatment_non_paid",
            treatment: formData.description,
          };
        } else {
          formDatas = {
            ...formData,
            selectedOption: "treatment_paid",
            treatment: formData.description,
            price: formData.prices * formData.quantity,
          };
        }
      } else {
        if (selectedPaid === "nonpaid") {
          formDatas = {
            ...formData,
            selectedOption: "treatment_non_paid",
          };
        } else {
          formDatas = {
            ...formData,
            selectedOption: "treatment_paid",
            price: formData.prices * formData.quantity,
          };
        }
      }
    }
    

    baseUrl
      .patch("/client/treatments/subTreatment/add-subtreetment", {
        ...formDatas,
        treatment_id: ID, // Send treatment_id as part of the body
        sub_treatment_id: TreatmentId, // Send sub_treatment_id as part of the body
      })
      .then((response) => {
        setSubTreatmentOpen(false);
        setallTeatment(response.data.data.treatment);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const [selectedOption, setSelectedOption] = useState<string>("nontreatment");

  const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedOption(event.target.value);
  };
  const [selectedPaid, setSelectedPaid] = useState<string>("nonpaid");

  const handlePaidChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedPaid(event.target.value);
  };
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="px-6 py-4 border-b border-slate-100 dark:border-slate-700 flex items-center justify-between bg-gradient-to-r from-primary to-primaryLight">
          <div className="flex items-center gap-3">
            <AddCircleIcon className="text-white" />
            <h2 className="text-xl font-bold text-white">Add Sub Treatment</h2>
          </div>
          <button
            onClick={() => setSubTreatmentOpen(false)}
            className="w-8 h-8 rounded-lg bg-white/20 hover:bg-white/30 flex items-center justify-center text-white transition-colors"
          >
            <CloseIcon sx={{ fontSize: 20 }} />
          </button>
        </div>

        {/* Type Toggle */}
        <div className="px-6 py-3 border-b border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-700/50">
          <div className="flex gap-2">
            {[
              { value: "treatment", label: "Treatment" },
              { value: "nontreatment", label: "Non Treatment" },
            ].map(({ value, label }) => (
              <label
                key={value}
                className={`flex-1 py-2 px-4 rounded-lg text-sm font-medium text-center cursor-pointer transition-all ${
                  selectedOption === value
                    ? "bg-gradient-to-r from-primary to-primaryLight text-white shadow-md"
                    : "bg-white dark:bg-slate-600 text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-slate-600 hover:bg-slate-100 dark:hover:bg-slate-600/80"
                }`}
              >
                <input
                  type="radio"
                  value={value}
                  checked={selectedOption === value}
                  onChange={handleOptionChange}
                  className="sr-only"
                />
                {label}
              </label>
            ))}
          </div>
        </div>

        {/* Form */}
        <form onSubmit={onsubmit} className="flex-1 overflow-y-auto p-6 space-y-4">
          {selectedOption === "treatment" ? (
            <>
              {/* Paid Toggle */}
              <div className="flex gap-2 p-1 bg-slate-100 dark:bg-slate-700/50 rounded-lg">
                {[
                  { value: "paid", label: "Paid" },
                  { value: "nonpaid", label: "Non Paid" },
                ].map(({ value, label }) => (
                  <label
                    key={value}
                    className={`flex-1 py-2 px-4 rounded-md text-sm font-medium text-center cursor-pointer transition-all ${
                      selectedPaid === value
                        ? "bg-white dark:bg-slate-600 text-primary shadow-sm"
                        : "text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200"
                    }`}
                  >
                    <input
                      type="radio"
                      value={value}
                      checked={selectedPaid === value}
                      onChange={handlePaidChange}
                      className="sr-only"
                    />
                    {label}
                  </label>
                ))}
              </div>

              {/* Treatment Select */}
              <div>
                <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Select Treatment</label>
                <select
                  onChange={onchange}
                  value={formData.treatments}
                  name="treatments"
                  className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
                >
                  <option value="others">Others</option>
                  {data?.map((item: any, i: number) => (
                    <option key={i} value={item._id + "/" + item.treatment + "/" + item.price}>
                      {item.treatment}
                    </option>
                  ))}
                </select>
                {error && formData.treatments === "" && (
                  <p className="text-xs text-red-500 mt-1">Treatment is required</p>
                )}
              </div>

              {/* Type Select */}
              {data
                ?.filter((item: any) => item._id === formData.treatmentId)
                ?.map((filteredItem: any) => filteredItem.type)
                ?.flat().length > 0 && (
                <div>
                  <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Select Type</label>
                  <select
                    onChange={onchange}
                    value={formData.types}
                    name="types"
                    className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
                  >
                    <option value="">Select type</option>
                    {data
                      ?.filter((item: any) => item._id === formData.treatmentId)
                      ?.map((filteredItem: any) => filteredItem.type)
                      ?.flat()
                      .map((item: any, i: number) => (
                        <option key={i} value={item._id + "/" + item.treatment + "/" + item.price}>
                          {item.treatment}
                        </option>
                      ))}
                  </select>
                </div>
              )}

              {/* Subtype Select */}
              {data
                ?.filter((item: any) => item._id === formData.treatmentId)
                .map((filteredItem: any) => filteredItem.type)
                ?.flat()
                ?.filter((item: any) => item._id === formData.typeId)
                .map((filteredItem: any) => filteredItem.subType)
                ?.flat().length > 0 && (
                <div>
                  <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Select Subtype</label>
                  <select
                    onChange={onchange}
                    value={formData.subtypes}
                    name="subtypes"
                    className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
                  >
                    <option value="">Select subtype</option>
                    {data
                      ?.filter((item: any) => item._id === formData.treatmentId)
                      .map((filteredItem: any) => filteredItem.type)
                      ?.flat()
                      ?.filter((item: any) => item._id === formData.typeId)
                      .map((filteredItem: any) => filteredItem.subType)
                      ?.flat()
                      .map((item: any, i: number) => (
                        <option key={i} value={item._id + "/" + item.treatment + "/" + item.price}>
                          {item.treatment}
                        </option>
                      ))}
                  </select>
                </div>
              )}

              {/* Price (for paid) */}
              {selectedPaid === "paid" && (
                <div>
                  <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Price *</label>
                  <input
                    value={formData.prices}
                    name="prices"
                    type="number"
                    onChange={onchange}
                    className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
                  />
                  {otherserror && formData.prices <= 0 && (
                    <p className="text-xs text-red-500 mt-1">Price must be greater than 0</p>
                  )}
                </div>
              )}

              {/* Quantity */}
              <div>
                <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Quantity</label>
                <input
                  value={formData.quantity}
                  name="quantity"
                  type="number"
                  onChange={onchange}
                  className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
                />
              </div>

              {/* Description (for Others) */}
              {openOther && (
                <div>
                  <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Description *</label>
                  <input
                    value={formData.description}
                    name="description"
                    type="text"
                    onChange={onchange}
                    placeholder="Enter description"
                    className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 placeholder-slate-500 dark:placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
                  />
                  {otherserror && formData.description === "" && (
                    <p className="text-xs text-red-500 mt-1">Description is required</p>
                  )}
                </div>
              )}
            </>
          ) : (
            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Reason *</label>
              <input
                value={formData.reason}
                name="reason"
                type="text"
                onChange={onchange}
                placeholder="Enter reason"
                className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 placeholder-slate-500 dark:placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
              />
              {reasonerror && formData.reason === "" && (
                <p className="text-xs text-red-500 mt-1">Reason is required</p>
              )}
            </div>
          )}

          {/* Tooth No & Surface */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Tooth No</label>
              <input
                value={formData.toothNo}
                name="toothNo"
                type="number"
                onChange={onchange}
                className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Surface</label>
              <input
                value={formData.surface}
                name="surface"
                type="text"
                onChange={onchange}
                className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
              />
            </div>
          </div>

          {/* Note */}
          <div>
            <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Note</label>
            <textarea
              ref={textareaRef}
              value={formData.note}
              name="note"
              onChange={onchange}
              rows={3}
              className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all resize-none"
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full py-3 rounded-xl bg-gradient-to-r from-primary to-primaryLight text-white font-medium hover:shadow-lg hover:shadow-primary/20 transition-all"
          >
            Add Sub Treatment
          </button>
        </form>
      </div>
    </div>
  );
}

export default AddSubTreatmentModel;
